import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

export interface BtcState {
  address?: string;
}

const initialState: BtcState = {
  address: undefined,
};

export const btcSlice = createSlice({
  name: 'btc',
  initialState,
  reducers: {
    setAddress: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAddress } = btcSlice.actions;

export const selectAddress = (state: RootState) => state.btc.address;

export default btcSlice.reducer;
